import { useCallback, useEffect, useRef } from 'react';
import { useFormStore, useFormStoreSelector } from "./use-form-store.js";
/**
 * Shared hook for collapsible state management.
 * Used by CollapsibleObjectSection, CollapsibleArrayItemWrapper, CollapsibleDiscriminatorField.
 */
export function useCollapsibleState(path, collapseByDefault) {
    const store = useFormStore();
    const isOpen = !useFormStoreSelector((s) => s.collapsed.has(path));
    const initialApplied = useRef(false);
    useEffect(() => {
        if (collapseByDefault && !initialApplied.current) {
            initialApplied.current = true;
            store.getState().setCollapsed(path, true);
        }
    }, [collapseByDefault, store, path]);
    const toggle = useCallback(() => {
        store.getState().setCollapsed(path, isOpen);
    }, [store, path, isOpen]);
    return { isOpen, toggle };
}
